import React, {useState, useContext, useEffect} from 'react';
import { IonLabel, IonInput, IonCol, IonRow, IonDatetime, IonText, IonModal, IonGrid, IonHeader, IonButton, IonLoading } from '@ionic/react';


import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import './Reservation_EnterBookingInfo_locals.css';

export function SelectDateRange_CheckIn(props) {
    
    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);


    const [acctID, setAcctID ] = useState(authMerchant_objects.acctID);
    const [schema, setSchemaName] = useState(authMerchant_objects.schema);

    let [viewCheckInDateModal, setCheckInDateModal] = useState(false);
    let [viewCheckOutDateModal, setCheckOutDateModal] = useState(false);

    let [disable_checkInSubmit, setDisable_checkInButton] = useState(true);
    let [disable_checkOutSubmit, setDisable_checkOutButton] = useState(true);

    //let [startDateRange, setStartDateRange] = useState(new Date());
    //let [endDateRange, setEndDateRange] = useState(new Date());

    let [startDateRange, setStartDateRange] = useState(new Date(new Date().setDate(new Date().getDate())));
    let [endDateRange, setEndDateRange] = useState(new Date(new Date().setDate(new Date().getDate()+1)));

    let [dateRangeNumberOfNights, setDateRangeNumberOfNights] = useState(0);
    const [inputClass_checkIn, setInputClass_checkIn] = useState('dateInput_col_red');
    const [inputClass_checkOut, setInputClass_checkOut] = useState('dateInput_col');

    let [isloading, setLoading] = useState(false);

  
    /*let [startMonth, setStartMonth] = useState(null);
    let [startDay, setStartDay] = useState(null);
    let [startYear, setStartYear] = useState(null);

    let [endMonth, setEndMonth] = useState(null);
    let [endDay, setEndDay] = useState(null);
    let [endYear, setEndYear] = useState(null);*/
    //let startMonth = startDateRange.toLocaleString('en-us', {month: 'long'});
    //let startDay = startDateRange.toLocaleString('en-us', {day: '2-digit'});
    //let startYear = startDateRange.getFullYear();

    //let endMonth = endDateRange.toLocaleString('en-us', {month: 'long'});
    //let endDay = endDateRange.toLocaleString('en-us', {day: '2-digit'});
    //let endYear = endDateRange.getFullYear();

    function getAvailableRooms(event)
    {

        if(event[0] == 'start')
        {
            setDisable_checkInButton(true);
        }
        if(event[0] == 'end')
        {
            setDisable_checkOutButton(true);
        }
   
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {'content-type': 'application/json' },
            body: JSON.stringify({
                Tracker: 'PUBLIC_74701',
                user: acctID,
                xCompanyID_public: props.data.companyID,
                xStartDateRange: event[1].toISOString().substr(0, 10),
                xEndDateRange: event[2].toISOString().substr(0, 10),

            }),
        }

        let newBaseURL = 'https://ghanaverified.com';
        if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
        {
            newBaseURL = 'https://ghanaverifiedtest.com'
        }

        //fetch(newBaseURL+'/public_request', requestOptions)
        fetch(baseURL+'ghanaverified/', requestOptions)
        .then(res => res.text())
        .then(res => {

        
        
                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                        if(rowLength >= 1 && event[0] == 'start')
                        {
                            setStartDateRange(event[1]);    
                            setInputClass_checkIn('dateInput_col');

                            let date1 = new Date( event[1]);
                            let date2 = new Date(event[2]);
                            let timeDiff = Math.abs(date2.getTime() - date1.getTime());
                            let calcNumberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24)); 

                            setDateRangeNumberOfNights(calcNumberOfNights);

                            // alert("BEFORE startDateRange >= endDateRange");
                            // alert(event[1]);
                            // alert(endDateRange);
                            // alert(event[1] >= endDateRange);

                            if(event[1] >= endDateRange)
                            {

                                setInputClass_checkOut('dateInput_col_red');
                            }
                            else
                            {

                                let roomColor = 'black';
                                if(timeDiff > 0)
                                {
                                    roomColor = 'red';
                                }

                                props.onCheckInDate({startDate:  event[1].toISOString().substr(0, 10), endDate:  event[2].toISOString().substr(0, 10), numOfNights: calcNumberOfNights, selectRoomColor: roomColor});

                            }

                            //setLoading(false);
                        }

                        if(rowLength >= 1 && event[0] == 'end')
                        {
                            setEndDateRange(event[2]);    

                            let date1 = new Date( event[1]);
                            let date2 = new Date(event[2]);
                            let timeDiff = Math.abs(date2.getTime() - date1.getTime());
                            let calcNumberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24)); 

                            setDateRangeNumberOfNights(calcNumberOfNights);

                            if(event[1] >= (event[2]))
                            {

                                setInputClass_checkOut('dateInput_col_red');
                            }
                            else
                            {
                                let roomColor = 'black';
                                if(timeDiff > 0)
                                {
                                    roomColor = 'red';
                                }

                                props.onCheckInDate({startDate:  event[1].toISOString().substr(0, 10), endDate:  event[2].toISOString().substr(0, 10), numOfNights: calcNumberOfNights, selectRoomColor: roomColor});


                                if((event[1] <= event[2]) && event[0] == "end")
                                {
                                    setInputClass_checkOut('dateInput_col');
                                }
                            }

                            //setLoading(false);

                        }




                        if(rowLength < 1)
                        {
                            alert('No Rooms Available. Please re-select');

                            // setDisable_checkInButton(true);
                            // setDisable_checkOutButton(true);  
                            // //setLoading(false);

                            // setCheckInDateModal(true);
                            // setCheckOutDateModal(false);
            
                            //document.getElementsByClassName('checkInDate')[0].style.backgroundColor ='rgb(245, 39, 80)';
                            //document.getElementsByClassName('checkOutDate')[0].style.backgroundColor ='rgb(245, 39, 80)';

                            //document.getElementById('searchAvailableRooms').innerHTML = '';
                
                        }

                        setLoading(false);
                    })
    };

    function handleSelectStartDateRange(e) { 

        setLoading(true);
        
            //setStartDateRange(e[0]);    
            //setEndDateRange(new Date(new Date().setDate(e[0].getDate()+1)));
            getAvailableRooms(['start', e[0], endDateRange]);

            setDisable_checkInButton(false);

    }

    function handleSelectEndDateRange(e) {   
        
        setLoading(true);
            //setEndDateRange(e[0]);    
            getAvailableRooms(['end', startDateRange, e[0]]);
            setDisable_checkOutButton(false);  
            
    }

    useEffect(() => {

        //alert('Please Select Check-In Date.');

        //setCheckInDateModal(true);
        setLoading(true);

        getAvailableRooms(['start', startDateRange, endDateRange]);
        
    }, []);

    function closeModalHandler()
    {
        setCheckInDateModal(false);
        setCheckOutDateModal(false);

        props.closeModal();
    }

    //alert("in select date range");
    //alert(startDateRange.toISOString().substr(0, 10));
    //alert(endDateRange.toISOString().substr(0, 10));

    return (
            <React.Fragment>
                    
                    <IonRow>
                            <IonCol size='6'> Check-In </IonCol>
                            <IonCol size='6'> Check-Out  </IonCol>
                        </IonRow>
                        <IonRow >
                            <IonCol className={inputClass_checkIn} size='6'>
                                <IonInput type='date' placeholder='Enter' value={startDateRange.toISOString().substr(0, 10)} min={new Date().toISOString().substr(0, 10)} onIonChange={(e)=> handleSelectStartDateRange([new Date(e.target.value)])}> </IonInput>
                            </IonCol>
                            <IonCol className={inputClass_checkOut} size='6'>
                                <IonInput type='date' placeholder='Enter' value={endDateRange.toISOString().substr(0, 10)} min={startDateRange.toISOString().substr(0, 10)} onIonChange={(e)=> handleSelectEndDateRange([new Date(e.target.value)])}> </IonInput>
                            </IonCol>
                        </IonRow>

                    {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}


            </React.Fragment>
            /*<IonRow>
                <IonCol size='4'>
                    <IonInput type='date' value={startDateRange.toISOString().substr(0, 10)} onIonChange={(e)=> handleSelectStartDateRange([new Date(e.target.value), endDateRange])}> </IonInput>  
                </IonCol>
                <IonCol size='4'>                    
                    <IonInput type='date' value={endDateRange.toISOString().substr(0, 10)} onIonChange={(e)=> handleSelectEndDateRange([startDateRange, new Date(e.target.value)])}> </IonInput>  
                </IonCol>
            </IonRow>*/
        /*<React.Fragment>
            <IonRow>
                <IonCol>
                    <IonLabel for='startDateRange'>Start: </IonLabel>
                    <IonInput type='date' id='startDateRange' onIonChange={handleSelectStartDateRange}>
                    </IonInput>
                    <div>{startMonth+ ' '+startDay+', '+startYear}</div>
                </IonCol>
                <IonCol>
                    <IonLabel for='endDateRange'>End: </IonLabel>
                    <IonInput type='date' id='endDateRange' onIonChange={handleSelectEndDateRange}>
                    </IonInput>
                    <div>{endMonth+ ' '+endDay+', '+endYear}</div>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel># of Nights: </IonLabel>
                    <p>{dateRangeNumberOfNights}</p>
                </IonCol>
            </IonRow>
        </React.Fragment>*/
    )

}